define(function (require) {
	// general
	const CN = require('civicsUtils/constants');
	// template
  const EmptyView = require('civicsViews/search_view/v_itv_empty_record_list');

	return Marionette.CollectionView.extend({
		tagName: 'ul',
		className:'results-list',
		initialize: function (options) {
			this.config = options.config;
			this.childView = options.childView;
    },
		childViewOptions: function(model, index) {
			return {
				config: this.config,
			};
		},
		childEvents: {
			itemSelected: function(model, value) {
				this.trigger('itemSelected', value);
			}
		},
    emptyView: EmptyView,
    emptyViewOptions: function (model, index) {
			return {
        emptyMessage: this.config.commonLabel.noRecordListMessage
			};
		},
		onRender: function () {
			if (__DEV__) console.log('cpv_collection onRender');
		},
	});
});
